import { TFunction } from 'react-i18next';
import { FORM_FIELDS, FORM_FIELDS_NAMES, IActivityLogFields } from './activity-log-form';
import { ISelectorData } from '../../components/application/NewApplication';
import { InputType } from '../../components/form/form-input-constants';

interface IActivityLogFieldsProps {
	t: TFunction,
	infoList: ISelectorData[],
	categoryList: ISelectorData[],
	allCategoryValue?: string[],
	allInformationValue?: string[],
	picker?: any;
}

export const ACTIVITY_LOG_FIELDS = ({ t, infoList, categoryList, picker, allCategoryValue, allInformationValue }: IActivityLogFieldsProps): IActivityLogFields[] => [
	{
		key: FORM_FIELDS.SEARCH,
		fieldName: FORM_FIELDS.SEARCH,
		placeholder: `${t(FORM_FIELDS_NAMES.SEARCH)}`,
		label: t(FORM_FIELDS_NAMES.SEARCH),
		inputType: InputType.Text,
		additionalClasses: 'col-md-5 mb-0 col-12'
	},
	{
		key: FORM_FIELDS.INFORMATION_LEVEL,
		fieldName: FORM_FIELDS.INFORMATION_LEVEL,
		placeholder: `${t(FORM_FIELDS_NAMES.INFORMATION_LEVEL)}`,
		label: t(FORM_FIELDS_NAMES.INFORMATION_LEVEL),
		inputType: InputType.MultiSelect,
		data: infoList,
		picker: picker,
		allValue: allInformationValue,
		searchable: false,
		additionalClasses: 'col-sm-4 col-md-3 col-12 mb-10 mb-md-0'
	},
	{
		key: FORM_FIELDS.CATEGORY,
		fieldName: FORM_FIELDS.CATEGORY,
		placeholder: `${t(FORM_FIELDS_NAMES.CATEGORY)}`,
		label: t(FORM_FIELDS_NAMES.CATEGORY),
		inputType: InputType.MultiSelect,
		data: categoryList,
		picker: picker,
		allValue: allCategoryValue,
		searchable: false,
		additionalClasses: 'col-sm-4 col-md-3 col-12 mb-10 mb-md-0'
	}
];
